import { ExpenseActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { ExpenseFormData } from 'src/screens/General/screens/Expenses/components/ExpenseForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetExpensesAction {
    type: typeof ExpenseActions.FETCH_EXPENSES;
    payload: QueryParams;
    all?: any;
}

export function getExpenses(params: QueryParams): GetExpensesAction {
    return {
        type: ExpenseActions.FETCH_EXPENSES,
        payload: params,
    };
}
interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getExpensesCsv(params: QueryParamsAll): GetExpensesAction {
    return {
        type: ExpenseActions.FETCH_EXPENSES_CSV,
        payload: params,
        all: params.all,
    };
}

export interface GetExpenseAction {
    type: typeof ExpenseActions.FETCH_EXPENSE;
    payload: {
        id: string | number;
    };
}

export function getExpense(id: string | number): GetExpenseAction {
    return {
        type: ExpenseActions.FETCH_EXPENSE,
        payload: { id },
    };
}

export interface DeleteExpenseAction {
    type: typeof ExpenseActions.DELETE_EXPENSE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteExpense(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteExpenseAction {
    return {
        type: ExpenseActions.DELETE_EXPENSE,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistExpenseAction {
    type: typeof ExpenseActions.PERSIST_EXPENSE;
    payload: {
        data: ExpenseFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistExpense(data: ExpenseFormData, callbacks: SagaPromise<any>): PersistExpenseAction {
    return {
        type: ExpenseActions.PERSIST_EXPENSE,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistExpense = (data: ExpenseFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistExpense(data, { resolve, reject }));
    });
};

export type Actions = GetExpensesAction | GetExpenseAction | DeleteExpenseAction | PersistExpenseAction;
